<template>
<div>

<div class="text-xs-center">
<v-dialog persistent v-model="likes.modals.checkGroup" width="950" scrollable>
<checker :modals='modals' :groups='groups' :likes='likes'>  </checker>
</v-dialog>
</div>


  <v-dialog  scrollable  width="450" persistent     v-model="likes.modals.addSrc">
  <add_groups :likes='likes' :modals='modals'> </add_groups>
  </v-dialog>



<delete_groups :modals='modals' :groups='groups'> </delete_groups>
<delete_selected :modals='modals' :groups='groups' :likes='likes'> </delete_selected>



    <v-dialog v-model="modals.history"  width="950" scrollable>
  <history :modals='modals' :groups='groups'>    </history>
  </v-dialog>









<v-container fluid >
<v-layout  d-flex>

<v-card>
<v-toolbar height="42" flat>
<v-toolbar-title style="color:#273C51;font-size:1.6em">Новые лайки постов</v-toolbar-title>
<v-spacer></v-spacer>
<v-tooltip top>
<span>Видео обзор</span>
<v-btn slot="activator" small flat icon @click="likes.modals.addSrc = true"   color="red"> <v-icon  >mdi-youtube</v-icon> </v-btn>
</v-tooltip>
</v-toolbar>

<v-card-text>
<v-layout  >
<div style="border:solid #E3E4E8 1px;border-radius:3px;min-width:550px;max-width:550px">

<v-select v-if="likes.catList.length != 0"
@change = "catData()" v-model = "likes.selectedCat"
dense solo :items="likes.catList"
>

<template slot="prepend-inner"     >
<v-btn icon dense  class="ma-0 pa-0">
<v-icon v-if="likes.selectedCat.status == '1'"  @click="groups.modals.renameCatSelected = true" color="#FF8F18">mdi-flash</v-icon>
<v-icon v-if="likes.selectedCat.status == '0'"  @click="groups.modals.renameCatSelected = true"  color="#808080">mdi-flash</v-icon>
</v-btn>
</template>

<template slot="append"  >
<v-tooltip top> <span>Добавить сообщества</span>
<v-btn slot="activator" @click = "likes.modals.addSrc = true" icon dense  class="ma-0 pa-0">
<v-icon  color="#273C51">mdi-plus</v-icon>
</v-btn>
</v-tooltip>
<v-tooltip top> <span>Настройки списка</span>
<v-btn slot="activator" icon dense class="ma-0 pa-0">
<v-icon @click.stop="groups.modals.renameCatSelected = true" color="#273C51">mdi-tune</v-icon>
</v-btn>
</v-tooltip>
<v-tooltip top> <span>Удалить список</span>
<v-btn slot="activator" icon dense class="ma-0 pa-0">
<v-icon @click.stop="likes.modals.removeCatSelected = true" color="red">mdi-close</v-icon>
</v-btn>
</v-tooltip>
</template>

<template slot="selection" >
<span>  {{likes.selectedCat.name}} ({{likes.srcAll.length}}) </span>
</template>

<template v-slot:item="{ item, attrs, on }">

<span v-if="item == likes.selectedCat" style="color:gray">  {{ item.name }} (текущий) </span>
<span v-else>  {{ item.name }} </span>

</template>
</v-select>



<v-dialog v-model="groups.modals.renameCatSelected" scrollable persistent max-width="950px">
<v-card>
<v-toolbar flat dark height="42" color="#273C51">
<v-toolbar-title>Редактировать -     {{likes.selectedCat.name}} </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon style="cursor: pointer"  @click.native="groups.modals.renameCatSelected = false" >mdi-close</v-icon>
</v-toolbar>

<v-card-text fluid   style="height: 550px;">
<v-text-field v-model="likes.selectedCat.name" label="Название списка"></v-text-field>

<v-autocomplete
v-model = "likes.selectedCat.params.task_list"
no-data-text = "Нет заданий для выбора"
:items="likes.taskList" hide-selected chips color="#4A76A8"
label="Выберите задания для экспорта новых лайков"
item-text="name" item-value="task_id" multiple
>
<template slot="selection" slot-scope="data">
<v-chip
:selected="data.selected" close class="chip--select-multi" @input="removeSelectedTaskForNewLikes(data.item)">
<v-avatar>
<v-icon>mdi-account-multiple</v-icon>
</v-avatar>
{{ data.item.name }}
</v-chip>
</template>

<template slot="item" slot-scope="data">
<v-list-tile-avatar>
<v-icon>mdi-account-multiple</v-icon>
</v-list-tile-avatar>
<v-list-tile-content>
<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
</v-list-tile-content>
</template>
</v-autocomplete>

<p style="color:#757575;font-size:1.3em">Постов с 1 ресурса</p>
<v-layout row style="margin-right:10px">
<v-flex class="px-3">
<v-subheader>Количество постов</v-subheader>
<v-slider v-model="likes.selectedCat.params.post_count" min="1" max="8" color="primary" thumb-label="always"></v-slider>
</v-flex>
</v-layout>

<p style="color:#757575;font-size:1.3em">Частота автообновления</p>
<v-layout row style="margin-right:10px">
<v-flex class="px-3">
<v-subheader>Секунды</v-subheader>
<v-slider v-model="likes.selectedCat.params.update_time.sec" min="1" max="59" color="primary" thumb-label="always"></v-slider>
</v-flex>

<v-flex class="px-3">
<v-subheader>Минуты</v-subheader>
<v-slider v-model="likes.selectedCat.params.update_time.min" max="59" color="primary" thumb-label="always"></v-slider>
</v-flex>

<v-flex class="px-3">
<v-subheader>Часы</v-subheader>
<v-slider max="23" v-model="likes.selectedCat.params.update_time.hours" color="primary" thumb-label="always"></v-slider>
</v-flex>
</v-layout>

</v-card-text>

<v-divider></v-divider>
<v-card-actions>

<v-btn style="text-transform:none"  color="#4A76A8"   flat @click="reductCatList()" block>
<v-icon> mdi-pencil </v-icon> <span style="margin-left:5px"> Редактировать список </span>
</v-btn>

</v-card-actions>
</v-card>
</v-dialog>




<v-dialog v-model="likes.modals.removeCatSelected" persistent scrollable max-width="350px">
<v-card style="min-height:300px" >

<v-toolbar flat dark color="red" height="42">
<v-toolbar-title> {{groups.selectedCat}} </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon style="cursor: pointer"  @click.native="likes.modals.removeCatSelected = false" >mdi-close</v-icon>
</v-toolbar>
<v-card-text fluid   style="height: 300px;">
Подтвердите удаление списка <span style="color:green">{{likes.selectedCat.name}}</span>,
отменить данное действие будет невозможно, <b>страницы или сообщества</b> данного списка будут
удалены. Так же будут удалены все <b>собранные лайки</b>.
</v-card-text>
<v-divider></v-divider>
<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none" color="#273C51" flat small   @click.native="likes.modals.removeCatSelected = false">Отмена</v-btn>
<v-btn style="text-transform:none" :loading="groups.removeList.loading"  :disabled="groups.removeList.loading" color="red" small class="white--text"  @click="deleteCatList()"><v-icon left>mdi-delete</v-icon> Удалить</v-btn>
</v-card-actions>
</v-card>
</v-dialog>


<groups_list v-for='(item, index) in likes.srcAll' :data='item' :index='index' :likes='likes' :modals='modals' :groups='groups'> </groups_list>


<div id="no_result"   v-if="likes.catList.length == 0 && likes.loadContent != true">
<span >
Для работы необходимо <span  @click="likes.modals.createCat = true" style="color:#273C51;cursor:pointer">создать</span> хотя бы один список, далее добавить в него список сообществ или страниц.
</span>
</div>

<div id="no_result"   v-if="likes.catList.length > 0 && likes.srcAll.length<1 && likes.loadContent != true">
<span >
Данный список пуст, для работы необходимо <span @click = "likes.modals.addSrc = true" style="color:#273C51;cursor:pointer">добавить</span> одно или несколько сообществ.
</span>
</div>


<div v-if="likes.loadContent === true" class="text-xs-center" style="marginTop:50px" >
<v-progress-circular :size="70" :width="7" color="#4A76A8" indeterminate></v-progress-circular>
</div>

</div>


<v-flex style="margin-left:20px; margin-right:15px;max-width:450px" >
<div  v-sticky sticky-offset="stickyOffset"    style=" border:solid #E3E4E8 1px; padding-left:5px;border-radius:3px">
<div   style="min-width:250px; max-width:450px"  >
<div    style="margin-top: 0px;">
<groups_meneger :groups='groups' :likes='likes' > </groups_meneger>
</div>
</div>
</div>
</v-flex>

</v-layout >
</v-card-text>
</v-card>

</v-layout >
</v-container>

</div>
</template>

<script>
import axios from 'axios'
import checker from './checker.vue'
import search_list from './search_list.vue'
import groups_list from './groups_list.vue'
import add_groups from './add_groups.vue'
import delete_groups from './delete_groups.vue'
import delete_selected from './deleteSelected.vue'
import history from './history.vue'
import groups_meneger from './groups_meneger.vue'
export default {
 components: {groups_list,add_groups,search_list,delete_groups,checker,history,delete_selected,groups_meneger},
 props:['groups','likes'],
 data: function(){
  return {

    stickyOffset: {
      top:55
    },
    ui: {
      loadingMore:false
    },

    modals :{
      addGroups:false,
      deleteGroup: false,
      deleteSelected: false,
      checkGroup: false,
      history: false
    }
  }
},

methods:{
removeSelectedTaskForNewLikes(item){
const index = this.likes.selectedCat.params.task_list.indexOf(item.task_id)
if (index >= 0) this.likes.selectedCat.params.task_list.splice(index, 1)
},

getCatList(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/get_cat_list.php',{
contentType: 'JSONP'
})
.then( response => {
if(response.data.length>0){
this.likes.selectedCat = response.data[0]
this.likes.catList = response.data
}

})
},





deleteCatList(){
this.groups.removeList.loading = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/change_list.php',{
method: 'POST',
data: {
type: 'delete_cat',
cat_id: this.likes.selectedCat.cat_id,
}
})
.then( response => {
this.$router.push({query: { cat_id: ''}})
this.$router.go()
})
},



reductCatList(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/change_list.php',{
method: 'POST',
data: {
type: 'ch_cat_params',
cat: this.likes.selectedCat,
}
})
.then( response => {
this.$router.go()
})
},




catData(){
this.$router.push({query: { cat_id: this.likes.selectedCat.cat_id }})
this.likes.srcAll = []
this.likes.loadContent = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/src_get_by_list.php', {
method: 'POST',
data : {catList:this.likes.catList, selectedCat:this.likes.selectedCat },
}).then(response => {
this.likes.loadContent = false
if(response.data.one.src){
   this.likes.srcAll = response.data.one.src
   this.likes.selectedCat = response.data.one.selectedCat
} else this.likes.srcAll = []
})
},


},
created(){
//this.getCatList()
},
mounted: function(){
let apper = 0
window.addEventListener('scroll',  ()=>{
this.ui.marginTop = window.scrollY+"px"
if(window.scrollY>100) {
this.ui.marginTop = window.scrollY - apper +"px"
if(apper<60){++apper;++apper; ++apper}
}
if(window.scrollY<10){apper = 0}
})
}
}


</script>

<style>
#wrapper{
  margin-top: 10px;
   margin-left: 25px ;
  border-radius: 2px;
  background-color: white;
  min-height:700px;
  width: 550px;
  border: solid 1px #E3E4E8
}
#search_list{
  margin-top: 30px;
}
.top_panel{
  background-color: #FAFBFC;
  width:100%;
  height: 40px;
  border-bottom: solid 1px #E3E4E8
}
#add_group{

  display: inline-block;
  float: right;

  margin: 7px  ;
}
.info_block{
  padding: 10px;


  display: inline-block;
  align-content: center;
}
#group_search_input_wrap{
  width:100%;
  margin-top: 15px;

}
#input_wrap{
  height: 35px;
  margin-left: 20px;
  width: 510px;
  border: solid 1px #E3E4E8;
  border-radius: 2px;
}
#search_btn {
  background-size: 45px 35px;
  display: inline-block;
  border-left: solid 1px #E3E4E8;
  height: 100%;
  width: 45px;
  float:right;
  background-color: #F0F2F5;
}
#search_btn:hover{
  background-color: #E9EBF0;
  cursor: pointer;
}


#input_wrapper{
  margin-left: 10px  ;
  height:100%;
  display: inline-block;
}
#input_groups {
  border: none;
  width:400px;
  margin-top: 8px;
}
#input_groups:focus {
  outline: none;
}


#groups_list {
  margin-top: 15px;

}
#no_result {
  margin-left: 10%;
  margin-top: 15px;
  width:80%;
  color:#9D9D9D;
  min-height: 45px;
  overflow:hidden
}
.selector:hover{
  border-bottom: solid #CAD2DB 2px
}
</style>
